var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
      [
        _c(
          "c-table",
          {
            ref: "table1",
            attrs: {
              title: "방지시설 보수내역",
              tableId: "table1",
              columns: _vm.grid1.columns,
              gridHeight: _vm.grid1.height,
              data: _vm.grid1.data,
              usePaging: false,
              hideBottom: true,
              columnSetting: false,
              filtering: false,
              isExcelDown: false,
            },
          },
          [
            _c(
              "template",
              { slot: "table-button" },
              [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    !_vm.param.isFullScreen
                      ? _c("c-btn", { attrs: { label: "저장", icon: "save" } })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }